package pl.decks.chartjs.radar.dataset

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptableIndexable

data class PointHoverProperties(
    val backgroundColor: JSScriptableIndexable<ChartColor>? = null,
    val borderColor: JSScriptableIndexable<ChartColor>? = null,
    val borderWidth: JSScriptableIndexable<Int>? = null,
    val radius: JSScriptableIndexable<Int>? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        if (backgroundColor != null) this.pointHoverBackgroundColor = backgroundColor.toChartJs { it.toChartJs() }
        if (borderColor != null) this.pointHoverBorderColor = borderColor.toChartJs { it.toChartJs() }
        if (borderWidth != null) this.pointHoverBorderWidth = borderWidth.toChartJs { it.asDynamic() }
        if (radius != null) this.pointHoverRadius = radius.toChartJs { it.asDynamic() }
    }
}
